<template>
  <transition name="fade">
    <v-overlay :value="preloaderStatus">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </transition>
</template>

<script>
export default {
  name: 'Preloader',
  computed: {
    preloaderStatus() {
      return this.$store.state.ui.preloaderStatus;
    },
  },
};
</script>

<style lang="scss" scoped src="./Preloader.scss" />
